import React from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import styles from './consentScreen.module.css';

import { ReactComponent as AuthenticateLogo } from 'asset/img/authenticate-logo.svg';

import ScreenFrame from '../../components/ScreenFrame';
import ThemedButton from '../../components/ThemedButton';
import { CONSENT_INFO_ROWS, CONSENT_VERIFIED_ICON } from '../../helper/constants';

const ConsentScreen = ({ logo, title, verifiedLine }) => {
    const rows = [
        { id: 'identity', icon: CONSENT_VERIFIED_ICON, text: verifiedLine },
        ...CONSENT_INFO_ROWS,
    ];

    return (
        <ScreenFrame
            logo={logo}
            title={title}
            footer={
                <ThemedButton>
                    <AuthenticateLogo className={styles.buttonLogo} />
                </ThemedButton>
            }
        >
            {rows.map(({ id, icon: Icon, text }) => (
                <Box key={id} className={styles.row}>
                    <Icon className={styles.icon} />
                    <Typography className={styles.text}>{text}</Typography>
                </Box>
            ))}
            <Box className={styles.terms}>
                <Box component="span" className={styles.checkbox} />
                <Typography className={styles.text}>
                    I agree to <span>Authenticating.com</span>&apos;s <span>Terms of Use</span> and{' '}
                    <span>Privacy Policy</span>, consent to the collection of my personal data and
                    facial biometrics (if applicable) for identity verification purposes and
                    acknowledge the <span>data retention policy</span>.
                </Typography>
            </Box>
        </ScreenFrame>
    );
};

ConsentScreen.propTypes = {
    logo: PropTypes.string,
    title: PropTypes.string.isRequired,
    verifiedLine: PropTypes.string.isRequired,
};

export default ConsentScreen;
